import React from "react";

const blogs = [
  {
    img: "/images/keyword/1.jpeg",
    title: "Pune Outstation Cab Service",
    desc: "Enjoy safe and comfortable family trips with Shivai Travels outstation taxi service.",
    link: "/Pune-Outstation-Cab-Service",
  },
  {
    img: "/images/keyword/4.jpg",
    title: "Best Cab Service in Pune",
    desc: "Spacious, comfortable and ideal for long-distance journeys with family and friends.",
    link: "/Best-Cab-Service-in-Pune",
  },
  {
    img: "/images/keyword/13.jpg",
    title: "Pune to Mumbai Cab",
    desc: "Best option for group tours, weddings, and corporate travel at budget prices.",
    link: "/Pune-to-Mumbai-Cab",
  },
];

const BlogSection = () => {
  return (
    <section className="shivai-blog-section p-0 py-2">
      <div className="container">

        {/* TITLE */}
        <div className="shivai-blog-title text-center">
          <span>Shivai Travels</span>
          <h2>Latest Travel Updates</h2>
          <p>Explore travel tips, cab services, and destination guides</p>
        </div>

        {/* BLOG GRID */}
        <div className="row">

          {blogs.map((blog, index) => (
            <div className="col-lg-4 col-md-6" key={index}>

              <div className="shivai-blog-card">

                {/* IMAGE */}
                <div className="shivai-blog-img">
                  <img src={blog.img} alt={blog.title} />
                </div>

                {/* CONTENT */}
                <div className="shivai-blog-content">

                  <h3>{blog.title}</h3>
                  <p>{blog.desc}</p>

                  {/* SAME TEXT, DIFFERENT LINK */}
                  <a href={blog.link} className="shivai-read">
                    Read More →
                  </a>

                </div>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default BlogSection;